import React from "react";

export const Warning: React.FC<React.SVGProps<SVGSVGElement>> = ({ width = 24, height = 24, ...props }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 2.75012C17.108 2.75012 21.25 6.89112 21.25 12.0001C21.25 17.1081 17.108 21.2501 12 21.2501C6.891 21.2501 2.75 17.1081 2.75 12.0001C2.75 6.89112 6.891 2.75012 12 2.75012Z"
      stroke="#707087"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M11.9941 8.20422V12.6232" stroke="#707087" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M11.995 15.7961H12.005" stroke="#707087" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
